export default __webpack_public_path__ + "static/media/tivitLogo.42da93b7.svg";